import { TruncationMode } from '../../../../../../typography/text-ellipsis/TextEllipsis.js';
import { LABEL_HOVERED_PADDING } from '../constants.js';
import { getVerticalLabelPosition } from './get-vertical-label-position.js';
import { calculateOptimalEllipsis } from './labels-collision.js';
import { charsFontWidth12pixelsSize500Map } from '../../../text-ellipsis/chars-font-width-map.js';
import {
  calculateWidth,
  TEXT_HEIGHT,
} from '../../../text-ellipsis/truncate-string.js';
import {
  HorizontalCoords,
  LabelAlignment,
  RangeLabel,
} from '../types/range-legend.internal.js';

/**
 * Check if for the given label position the text will fit in the bounds of the container.
 * In the case where the label does not fit applies the ellipsis to it.
 */
export const handleCollisionInVerticalLayout = (
  labelText: string,
  segment: HorizontalCoords,
  alignment: LabelAlignment,
  truncationMode: TruncationMode,
  bounds: number[],
): RangeLabel => {
  const labelWidth = calculateWidth(
    labelText,
    charsFontWidth12pixelsSize500Map,
  );
  const labelHeight = TEXT_HEIGHT;
  const { x, y } = getVerticalLabelPosition(
    labelHeight,
    segment.start,
    segment.end,
    alignment,
  );

  const isTruncationNeeded = x + LABEL_HOVERED_PADDING + labelWidth > bounds[1];

  if (isTruncationNeeded) {
    const { text } = calculateOptimalEllipsis(
      labelText,
      x,
      x + labelWidth,
      truncationMode,
      bounds[0],
      bounds[1],
    );

    return { text, x, y };
  }

  return { text: labelText, x, y };
};
